export function validateEmail(value) {
  return !/^[A-Z0-9._%+'-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i.test(value)
    ? "Invalid email address!"
    : "";
}
